import { render, staticRenderFns } from "./EsgLcaEmissionAmountManagement.vue?vue&type=template&id=9fe45f5a"
import script from "./EsgLcaEmissionAmountManagement.vue?vue&type=script&lang=js"
export * from "./EsgLcaEmissionAmountManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports